import * as i0 from '@angular/core';
import { Directive, TemplateRef, ViewChild, ContentChild, Input, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
const _c0 = ["frontside"];
const _c1 = ["backside"];
function ZvFlipContainer_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0._frontTemplate);
  }
}
function ZvFlipContainer_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0._backTemplate);
  }
}
let FlipContainerFront = /*#__PURE__*/(() => {
  class FlipContainerFront {
    el;
    constructor(el) {
      this.el = el;
    }
    static ɵfac = function FlipContainerFront_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FlipContainerFront)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FlipContainerFront,
      selectors: [["", "zvFlipContainerFront", ""]]
    });
  }
  return FlipContainerFront;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FlipContainerBack = /*#__PURE__*/(() => {
  class FlipContainerBack {
    el;
    constructor(el) {
      this.el = el;
    }
    static ɵfac = function FlipContainerBack_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FlipContainerBack)(i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FlipContainerBack,
      selectors: [["", "zvFlipContainerBack", ""]]
    });
  }
  return FlipContainerBack;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvFlipContainer = /*#__PURE__*/(() => {
  class ZvFlipContainer {
    cd;
    removeHiddenNodes = true;
    animation = 'flip';
    get active() {
      return this._active;
    }
    _frontTemplate = null;
    _backTemplate = null;
    _frontside;
    _backside;
    get _activeState() {
      return this.animation + '_' + this.active;
    }
    _active = 'front';
    _attachFront = true;
    _attachBack = false;
    constructor(cd) {
      this.cd = cd;
    }
    ngAfterViewInit() {
      this._backside.nativeElement.hidden = true;
    }
    showFront() {
      this.show('front');
    }
    showBack() {
      this.show('back');
    }
    _timerRef = 0;
    show(show) {
      if (this._active !== show) {
        this._active = show;
        this.cd.markForCheck();
        this._flipStart();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        clearTimeout(this._timerRef);
        this._timerRef = setTimeout(() => {
          this._flipDone();
        }, 300);
      }
    }
    toggleFlip() {
      this.show(this._active === 'front' ? 'back' : 'front');
    }
    _flipStart() {
      if (this._active === 'back') {
        this._backside.nativeElement.hidden = false;
        this._attachBack = true;
      } else {
        this._frontside.nativeElement.hidden = false;
        this._attachFront = true;
      }
      this.cd.markForCheck();
    }
    _flipDone() {
      if (this._active === 'back') {
        this._frontside.nativeElement.hidden = true;
        this._attachFront = false;
      } else {
        this._backside.nativeElement.hidden = true;
        this._attachBack = false;
      }
      this.cd.markForCheck();
    }
    static ɵfac = function ZvFlipContainer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvFlipContainer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvFlipContainer,
      selectors: [["zv-flip-container"]],
      contentQueries: function ZvFlipContainer_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, FlipContainerFront, 5, TemplateRef);
          i0.ɵɵcontentQuery(dirIndex, FlipContainerBack, 5, TemplateRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._frontTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._backTemplate = _t.first);
        }
      },
      viewQuery: function ZvFlipContainer_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
          i0.ɵɵviewQuery(_c1, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._frontside = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._backside = _t.first);
        }
      },
      inputs: {
        removeHiddenNodes: "removeHiddenNodes",
        animation: "animation"
      },
      decls: 8,
      vars: 8,
      consts: [["frontside", ""], ["backside", ""], [1, "zv-flip-container__container"], [1, "zv-flip-container__flip-box"], [1, "zv-flip-container__side", "zv-flip-container__side__front"], [3, "ngTemplateOutlet"], [1, "zv-flip-container__side", "zv-flip-container__side__back"]],
      template: function ZvFlipContainer_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4, 0);
          i0.ɵɵtemplate(4, ZvFlipContainer_Conditional_4_Template, 1, 1, "ng-container", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 6, 1);
          i0.ɵɵtemplate(7, ZvFlipContainer_Conditional_7_Template, 1, 1, "ng-container", 5);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap("zv-flip-container__animation-" + ctx.animation);
          i0.ɵɵadvance();
          i0.ɵɵclassMap("zv-flip-container__flip-box--active-" + ctx._active);
          i0.ɵɵadvance();
          i0.ɵɵattribute("inert", !ctx._attachFront || null);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx._attachFront || !ctx.removeHiddenNodes ? 4 : -1);
          i0.ɵɵadvance();
          i0.ɵɵattribute("inert", !ctx._attachBack || null);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx._attachBack || !ctx.removeHiddenNodes ? 7 : -1);
        }
      },
      dependencies: [NgTemplateOutlet],
      styles: [".zv-flip-container__flip-box[_ngcontent-%COMP%]{display:grid;grid-template-areas:\"content\"}.zv-flip-container__side[_ngcontent-%COMP%]{grid-area:content}.zv-flip-container__animation-flip.zv-flip-container__container[_ngcontent-%COMP%]{perspective:100%}.zv-flip-container__animation-flip[_ngcontent-%COMP%]   .zv-flip-container__flip-box[_ngcontent-%COMP%]{position:relative;transform-style:preserve-3d;transition:transform .3s ease-in-out}.zv-flip-container__animation-flip[_ngcontent-%COMP%]   .zv-flip-container__side[_ngcontent-%COMP%]{backface-visibility:hidden}.zv-flip-container__animation-flip[_ngcontent-%COMP%]   .zv-flip-container__side__back[_ngcontent-%COMP%]{transform:rotateY(180deg)}.zv-flip-container__animation-flip[_ngcontent-%COMP%]   .zv-flip-container__side__front[_ngcontent-%COMP%], .zv-flip-container__animation-flip[_ngcontent-%COMP%]   .zv-flip-container__flip-box--active-front[_ngcontent-%COMP%]{transform:rotateY(0)}.zv-flip-container__animation-flip[_ngcontent-%COMP%]   .zv-flip-container__flip-box--active-back[_ngcontent-%COMP%]{transform:rotateY(180deg)}.zv-flip-container__animation-fade[_ngcontent-%COMP%]   .zv-flip-container__side__front[_ngcontent-%COMP%]{z-index:1}.zv-flip-container__animation-fade[_ngcontent-%COMP%]   .zv-flip-container__flip-box--active-front[_ngcontent-%COMP%]   .zv-flip-container__side__back[_ngcontent-%COMP%]{opacity:0;animation:.3s linear _ngcontent-%COMP%_fadeOut}.zv-flip-container__animation-fade[_ngcontent-%COMP%]   .zv-flip-container__flip-box--active-front[_ngcontent-%COMP%]   .zv-flip-container__side__front[_ngcontent-%COMP%], .zv-flip-container__animation-fade[_ngcontent-%COMP%]   .zv-flip-container__flip-box--active-back[_ngcontent-%COMP%]   .zv-flip-container__side__back[_ngcontent-%COMP%]{opacity:1;animation:.3s linear _ngcontent-%COMP%_fadeIn}.zv-flip-container__animation-fade[_ngcontent-%COMP%]   .zv-flip-container__flip-box--active-back[_ngcontent-%COMP%]   .zv-flip-container__side__front[_ngcontent-%COMP%]{opacity:0;animation:.3s linear _ngcontent-%COMP%_fadeOut}@keyframes _ngcontent-%COMP%_fadeOut{0%{opacity:1}50%{opacity:0}to{opacity:0}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}50%{opacity:0}to{opacity:1}}"],
      changeDetection: 0
    });
  }
  return ZvFlipContainer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ZvFlipContainerModule = /*#__PURE__*/(() => {
  class ZvFlipContainerModule {
    static ɵfac = function ZvFlipContainerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvFlipContainerModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ZvFlipContainerModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return ZvFlipContainerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// export what ./public_api exports so we can import with the lib name like this:
// import { ModuleA } from 'libname'

/**
 * Generated bundle index. Do not edit.
 */

export { FlipContainerBack, FlipContainerFront, ZvFlipContainer, ZvFlipContainerModule };
